import http from "@seims/shared/src/services/HttpService";
import Partner from "../data/Partner";

var endpoint = `/partnership/`;

const headers = {};

const getPartnerships = async ({first, max, searchText=""}) => {

  var urlPath = `${endpoint}list?offset=${first}&limit=${max}&searchText=${searchText}`;

  const response = await http.get(`${urlPath}`);
  return response;
};

const addPartnership = async (
  partner,
  representatives,
  address
) => {
  const entity = "partner";
  let msg = "";

  const response = await http.post(
    `${endpoint}create`,
    {
      "id": -1,
      "uuid": "00000000-0000-0000-0000-000000000000",
      "name": partner.name,
      "initiationDate": new Date(partner.initiationDate).toISOString(),
      "lastEngagementDate": new Date().toISOString(), //still to be confirmed
      "telephoneNumber": partner.contact,
      "email": partner.email,
      "archived": false,
      "userId": 'ff1cbfc5-9087-4e6b-bcd1-d0ecd60288d2', //partner.userId,
      "representatives": representatives,
      "contributions": partner.contributions,
      "partnerType": partner.partnerType,
      "locality": partner.address,
      "active": true,
      "reportedOn": true,
      "otherContribution": partner.other,
      "address": {
        "id": -1,
        "country": address.country,
        "province": address.province,
        "cityOrTown": address.cityOrTown,
        "street": address.street,
        "postalCode": address.postalCode,
      },
      
    },
    { headers: headers }
  );
    return response;
};

const updatePartnership = (
  partner,
  representatives,
  address
) => {

  const response = http.put(
    `${endpoint}update`,
    {
      "id": partner.id,
      "uuid": "00000000-0000-0000-0000-000000000000",
      "name": partner.name,
      "initiationDate": new Date(partner.initiationDate).toISOString(),
      "lastEngagementDate": new Date().toISOString(),
      "telephoneNumber": partner.contact,
      "email": partner.email,
      "archived": false,
      "userId": 'ff1cbfc5-9087-4e6b-bcd1-d0ecd60288d2', //partner.userId,
      "representatives": representatives,
      "contributions": partner.contributions,
      "partnerType": partner.partnerType, 
      "locality": partner.address,
      "active": partner.active,
      "reportedOn": partner.reportedOn,
      "otherContribution": partner.other,
      "address": {
        "id": address.id,
        "country": address.country,
        "province": address.province,
        "cityOrTown": address.cityOrTown,
        "street": address.street,
        "postalCode": address.postalCode,
      },
      
    },
    { headers: headers }
    );
    return response;
};

const getPartnerTest =  (id) => {
  const response = Partner.partnerList.filter((record)=> record.id == id );
  return response;
};

const getPartner = async (id) => {
  const response = await http.get(`${endpoint}${id}`);
  return response;
};

export default {
  getPartnerships,
  addPartnership,
  getPartner,
  updatePartnership
};
